import { ZoomIn } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ZoomInIcon = DeckardIconWrapper({ Icon: ZoomIn });
